<template>
    <div class="d-flex align-center justify-center w-100">
        <div 
            class="mr-auto"
            v-if="currentPage !== 1"
            >
            <x-ArrowButtonOutline
                :width="'190px'"
                :height="'10vh'"
                @brClick="$emit('back')"
                v-ripple
            >
                <span class="secondary--text text-body-2 font-weight-bold">
                    {{ $t('go_back') }}
                </span>
            </x-ArrowButtonOutline>
        </div>
        <div v-if="!isLastPage" class="py-2 px-3 bg-white shadow-lg border-radius-2 mx-auto">
            <span class="text-upppercase text-center footer-text">
                {{ currentPage }}
                <span class="opacity-6">{{ $t('of') }} {{ totalPages }}</span>
            </span>
        </div>
        <div v-if="isLastPage" class="col" style="max-width:300px">
            <v-btn
                data-cy="challengeFooter-goToQuestion-button"
                dark
                class="bg-gradient-primary font-weight-bolder text-body-1"
                large
                block
                :style="{ textTransform: 'none' }"
                @click="$emit('finish')"
            >
                {{$t('challenge.go_to_questions')}}
            </v-btn>
        </div>
        <div class="ml-auto" v-if="!isLastPage">
            <x-ArrowButton :width="'200px'" :height="'10vh'" @brClick="$emit('next')" v-ripple>
                <span class="white--text text-body-2 font-weight-bold">
                    {{ $t('next') }}
                </span>
            </x-ArrowButton>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ChallengeFooter',
    props: {
        isLastPage: { type: Boolean, default: false },
        currentPage: { type: [String, Number], default: '' },
        totalPages: { type: [String, Number], default: '' },
    },
}
</script>
